import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconFileText = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <g>
        {/* Контур файлу */}
        <path
          fill={fill}
          opacity={0.3}
          d='M6 2h7l5 5v13a2 2 0 0 1-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2z'
        />

        {/* Лінії-текст */}
        <path
          fill={fill}
          d='M8 11h8c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h5c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1z'
        />

        {/* Верхній згин файлу */}
        <path
          fill={fill}
          d='M13 2v5h5l-5-5z'
        />
      </g>
    </svg>
  )
}

export default IconFileText